import { StyleSheet, Platform } from 'react-native'
// import Color from 'color'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const styles = StyleSheet.create({
  container: {
    paddingVertical: v.SPACE_SM,
  },
  actionBox: {
    marginVertical: v.SPACE_LG,
  },
  iconContainer: {
    marginTop: Platform.OS === 'android' ? 4 : 0,
    width: 38,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  settingBox: {
    paddingHorizontal: v.SPACE_SM,
  },
  patientGroupContainerStyle: {
    borderColor: 'red',
    marginBottom: v.SPACE_XS,
  },
  patientGroupTabStyle: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    borderBottomWidth: 2,
    borderColor: colors.grayLight,
  },
  patientGroupActiveTabStyle: {
    backgroundColor: 'transparent',
    borderColor: colors.blue,
  },
  patientGroupTextStyle: {
    fontFamily: v.FONT_FAMILY_BASE,
    color: colors.grayDark,
    marginVertical: v.SPACE_XS,
    // fontWeight: 'bold'
  },
  patientGroupActiveTabTextStyle: {
    color: colors.blue,
  },
  centeredContent: {
    alignItems: 'center',
    paddingVertical: v.SPACE_MD,
  },
  bold: {
    fontFamily: v.FONT_FAMILY_BOLD,
  },
})

export default styles
